import * as actionTypes from '../action_types/login';

export const updateLoginType = (type) => ({
  type: actionTypes.POST_LOGIN_TYPE,
  payload: {
    type,
  },
});
